// Modules
import styled from 'styled-components';

// Styles
import { Body, BodyBoldTwo } from '../../styles/common/typo.styles';

// Types
import { styledComponentProps } from '../../types/theme';

export const Checkout = styled.a`
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};
	font-size: 16px;
	font-weight: 500;
	line-height: 1;
	text-decoration: none;
	width: 100%;
	padding: 16px 20px 16px 16px;
	margin: 20px 0 8px;
	background-color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.lightBlue};
	cursor: pointer;
`;

export const CheckoutIcon = styled.img<any>`
	width: 43px !important;
	height: 13px !important;
	${({ direction }: styledComponentProps): string => {
		if (direction === 'ltr') {
			return `transform:  rotate(180deg)`;
		}
		return ''
	}};
	transition: 0.2s all ease-in;
	${({ direction, hover }: styledComponentProps): string => {
		return direction === 'rtl'
			? `margin-left: ${hover ? -.5 : 0}rem;`
			: `margin-right: ${hover ?  -.5 : 0}rem;`;
	}}
`;


export const PBold = styled(BodyBoldTwo)`
	color: ${({ theme }: styledComponentProps): string =>
		theme.colors.ui.barIlanGreen};
`;

